import React from "react";
import { RiStarFill, RiHeartFill, RiEyeFill } from "react-icons/ri";

import dataEn from "../../../languages/en/fourSec";
import dataTh from "../../../languages/th/fourSec";

const FourthSection = ({ language }) => {
  const data = language === "en" ? dataEn : dataTh;
  return (
    <section
      className=" mx-auto px-4 flex flex-col md:flex-row items-center justify-center
    lg:justify-between lg:items-end"
    >
      {/* left side */}
      <div className="lg:w-1/2 lg:ml-40">
        <img
          src={process.env.PUBLIC_URL + "/about us/BOX2/UI/block2.png"}
          alt="Image"
          className="h-full object-cover  w-500"
        />
      </div>

      {/* Right side */}

      <div
        className=" mb-8 w-4/5  ml-6
      lg:w-1/2"
      >
        <div className="hidden md:flex">
          <div
            className="flex justify-center items-center h-20 w-20 rounded-full"
            style={{ backgroundColor: "#1090CB" }}
          >
            <img
              src={process.env.PUBLIC_URL + "/about us/BOX1/UI/happy.svg"}
              alt="Image"
              className="h-12 w-12"
            />
          </div>

          <div className="flex font-prompt text-lg text-black mb-6 ml-4 items-start flex-col">
            <p className="font-prompt font-bold text-2xl text-black mb-4">
              {data.title}
            </p>
            <p className="font-prompt  text-neutral-1 ">{data.desc1}</p>
          </div>
        </div>

        {/* Big Title */}
        <h2 className="font-prompt font-bold text-2xl  mb-6">
          {data.heading1} <br /> {data.heading2}
        </h2>
        {/* Paragraph */}
        <p className="font-prompt  text-neutral-1 mb-6">
          {data.desc2} <br /> {data.desc3} <br /> {data.desc4} <br />{" "}
          {data.desc5} <br /> {data.desc6}
        </p>
      </div>
    </section>
  );
};

export default FourthSection;
